import { ContestTier } from '../types/Product';

export const getContestTier = (string: string): ContestTier | undefined => {
    const lowerCaseString = string.toLowerCase();

    if (lowerCaseString.includes('bronze')) {
        return ContestTier.Bronze;
    } else if (lowerCaseString.includes('silver')) {
        return ContestTier.Silver;
    } else if (lowerCaseString.includes('gold')) {
        return ContestTier.Gold;
    } else if (lowerCaseString.includes('platinum')) {
        return ContestTier.Platinum;
    }

    return undefined;
};
